var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.198,
    height: 29.197,
    viewBox: "0 0 29.162 26.825",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.581,2.929,26.368,24.62H2.794L14.581,2.929m0-2.929a1.485,1.485,0,0,0-1.327.754l-13.1,24.1a1.372,1.372,0,0,0,1.327,1.972H27.677A1.372,1.372,0,0,0,29,24.853L15.908.754A1.485,1.485,0,0,0,14.581,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.569,9.761a1.1,1.1,0,0,0-1.254-.553,1.122,1.122,0,0,0-.869,1.124v7.722a1.137,1.137,0,0,0,2.274,0c0-2.877,0-4.846,0-7.724a1.309,1.309,0,0,0-.146-.569"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.572,20.433a1.14,1.14,0,1,0,1.149,1.131v0a1.14,1.14,0,0,0-1.149-1.129"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.e30f3823d2ec5ff82af4fee5798f59f6.svg";
export { ForwardRef as ReactComponent };